import {
    createNewFolder,
    creatingNewFolderFailed,
    loadFolders,
    loadingFileProvidersFailed,
    loadingFoldersFailed,
    openFolderSelector,
    reloadFolders,
} from '../actions/internalActions';
import { FolderSelectorError } from '../store/schema/FolderSelectorError';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(openFolderSelector, clearError);
mutator(loadFolders, clearError);
mutator(reloadFolders, clearError);
mutator(createNewFolder, clearError);

mutator(creatingNewFolderFailed, actionMessage => {
    const { error } = actionMessage;
    getStore().error = error;
});

mutator(loadingFoldersFailed, actionMessage => {
    const { error } = actionMessage;
    getStore().error = error;
});

mutator(loadingFileProvidersFailed, () => {
    getStore().error = FolderSelectorError.UnableToLoadFileProviders;
});

function clearError() {
    getStore().error = FolderSelectorError.None;
}
